import {Box} from '@mui/material';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import ArrSingleSelectDropdown from '../../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {useCallback, useEffect, useState} from 'react';
import {ISelectItem} from '../../../../../shared/types';
import {t} from 'i18next';
import {useGetRedactionTags} from '../../../../../hooks/document/useDocument';
import './RedactionMenu.scss';

const enRedactionMenu = 'docView.redationMenu';

export interface SingleRedactionPopupProps {
  closeSingeRedactionPopup: () => void;
  saveSingleRedaction: () => void;
  selectedValue: ISelectItem | null;
  setSelectedValue: React.Dispatch<React.SetStateAction<ISelectItem | null>>;
}
const SingleRedactionPopup = ({
  closeSingeRedactionPopup,
  saveSingleRedaction,
  selectedValue,
  setSelectedValue,
}: SingleRedactionPopupProps) => {
  const [redactionOptions, setRedactionOptions] = useState<ISelectItem[]>([]);
  const {data} = useGetRedactionTags(true);
  useEffect(() => {
    setRedactionOptions(
      data?.redactionTagDetails.map((tag) => {
        return {
          id: tag.redactionID,
          name: tag.name,
          isDefault: tag.isSelected,
        } as ISelectItem;
      }) ?? []
    );
  }, [data]);

  useEffect(() => {
    const defaultOption = redactionOptions.find((item) => item.isDefault);
    if (defaultOption) {
      setSelectedValue(defaultOption);
    }
  }, [redactionOptions, setSelectedValue]);

  const onClose = useCallback(() => {
    setRedactionOptions([]);
    closeSingeRedactionPopup();
  }, [closeSingeRedactionPopup, setRedactionOptions]);

  const onSave = useCallback(() => {
    setRedactionOptions([]);
    saveSingleRedaction();
  }, [saveSingleRedaction, setRedactionOptions]);

  return (
    <ArrModal
      showModal={true}
      headerTitleClassName="headline3_size"
      headerTitle={t(`${enRedactionMenu}.popupTitle`)}
      description={t(`${enRedactionMenu}.popupDescription`)}
      onClose={onClose}
      className="save-redaction-single-popup"
      dataTestId="save-redaction-single-popup"
      buttons={[
        {
          id: 'cancel-button',
          label: t('common.cancel'),
          dataTestId: 'srs-cancel-button',
          onClick: onClose,
          variant: 'secondary',
        },
        {
          id: 'delete-button',
          label: t('common.save'),
          dataTestId: 'srs-delete-button',
          onClick: onSave,
          variant: 'primary',
        },
      ]}
    >
      <Box className="redaction-tags-dropdown-wrapper-box">
        {redactionOptions?.length > 0 && (
          <ArrSingleSelectDropdown
            dropdownLabel={t(`${enRedactionMenu}.popupDropdownLabel`)}
            dropdownItems={redactionOptions}
            selectedValues={selectedValue}
            onSelectionChange={setSelectedValue}
            dataTestId={'asd-popupDropdownLabel'}
          />
        )}
      </Box>
    </ArrModal>
  );
};

export default SingleRedactionPopup;
